//Making the select box from the p tags
var optionBox = document.getElementsByClassName("contact-options")[0];

if (optionBox != undefined) {

	var ptags = optionBox.getElementsByTagName("p");
	var selectBox = document.getElementById("ContactFormWHATCANWEHELPYOUWITH?");


	for (var i = 0; i < ptags.length; i++) {

		var e = ptags[i];
		optionBox.remove(e);
		var o = document.createElement('option');
		o.innerText = e.innerText;

		selectBox.appendChild(o);
	}
}

//Accordion navigation - Mobile

var openMenu = document.getElementsByClassName("footer-header");


for (var i = 0; i < openMenu.length; i++) {

	openMenu[i].addEventListener("click", function() {

		this.classList.toggle("active");
	
  	});
}

$( document ).ready(function() {

	$(document).on('click','.homepage-video-play-button, .homepage-video-play-button-inner', function(){
		$(this).css('outline','none');
	});

	$('#insta-feed').closest('.homepage-sections-wrapper').css('padding','20px');

	$(document).on('click','.view-more-reviews', function(){

		$(this).toggleClass('show-less');
		$('.spr-reviews > div').toggleClass('show-reviews');

		var getToTop = $('#shopify-product-reviews').offset().top;
		$('html, body').animate({
			scrollTop: getToTop + 500
		},400);
	});

});


$( window ).on("load", function() {
	var getReviewContainer = $('#shopify-product-reviews').parent();
	getReviewContainer.append( "<span class='view-more-reviews'></span>" );
});
